import { useCallback,useEffect,useState } from "react";
import { toast } from "react-toastify";
import { Button } from "src/Components";
import { CoveredMatrixOrderItemTableReport } from "src/Interfaces/coveredMatrixOrder";
import { CCOrderTablePause,CCOrderTablePlay } from "src/Requests/ccOrder";
import { IAdditional,IExtraTypeUIProps,ITableUI } from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { ExtraType } from "src/Interfaces/TableInterfaces";
import { TableCell } from "@mui/material";
import { packetErrorHandler } from "src/Utils/requestUtils";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import ChartSearchParamUI from "src/Pages/CoveredCall/ChartSearchParamUI";
import { MatrixItemVolumeDetailsModal } from "../Modals/VolumeDetailsModal";

export const MatrixItemPlaybackCell=({ row,onAction }: {
  row: CoveredMatrixOrderItemTableReport;
  onAction: () => void;
}) => {
  const [loading,setLoading]=useState(false);
  const canToggle=Boolean(row.coveredCallOrderId)&&!loading;
  const toggleActive=(event: React.MouseEvent<SVGSVGElement>) => {
    event.stopPropagation();
    if(!row.coveredCallOrderId||loading)
      return;
    setLoading(true);
    const request=row.isActive? CCOrderTablePause:CCOrderTablePlay;
    request([row.coveredCallOrderId])
      .then(() => {
        toast.success(row.isActive? "زیرسفارش متوقف شد.":"زیرسفارش فعال شد.");
        onAction();
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };
  return <TableCell
    onClick={(event) => event.stopPropagation()}
    className="!w-8 !min-w-8 !max-w-8 !p-0 !text-center"
  >
    {row.isActive
      ? <PauseCircleIcon
        titleAccess="توقف زیرسفارش"
        onClick={toggleActive}
        className={canToggle? "text-sky-700 cursor-pointer":"text-gray-300"}
      />
      :<PlayCircleIcon
        titleAccess="فعال‌سازی زیرسفارش"
        onClick={toggleActive}
        className={canToggle? "text-sky-700 cursor-pointer":"text-gray-300"}
      />}
  </TableCell>;
};

export const getMatrixItemTableAdditional=(onDetails: (row: CoveredMatrixOrderItemTableReport) => void): IAdditional<CoveredMatrixOrderItemTableReport> => ({
  getHeader: () => <>
    <TableCell className="!w-8 !min-w-8 !max-w-8 !p-0" />
    <TableCell className="!w-[62px] !min-w-[62px] !max-w-[62px] !px-1 !py-0 text-center">جزئیات</TableCell>
  </>,
  getRow: ({ row,onAction }) => <>
    <MatrixItemPlaybackCell row={row} onAction={onAction} />
    <TableCell
      onClick={(event) => event.stopPropagation()}
      className="!w-[62px] !min-w-[62px] !max-w-[62px] !px-1 !py-0 text-center"
    >
      <Button
        variant="contained"
        text="جزئیات"
        onClick={() => onDetails(row)}
        className="table-btn !w-14 !min-w-14"
      />
    </TableCell>
  </>,
});

export const MatrixItemTableContent=({ reports,onAction,sortingType,setSortingType,getExtraTypeUI }: ITableUI<CoveredMatrixOrderItemTableReport>) => {
  const [detailsItemId,setDetailsItemId]=useState<number|null>(null);
  const [detailsSnapshot,setDetailsSnapshot]=useState<CoveredMatrixOrderItemTableReport|null>(null);
  const currentDetailsRow=detailsItemId===null
    ? null
    :reports?.report?.find((row: CoveredMatrixOrderItemTableReport) => row.id===detailsItemId)||null;
  useEffect(() => {
    if(currentDetailsRow)
      setDetailsSnapshot(currentDetailsRow);
  },[currentDetailsRow]);
  const openDetails=useCallback((row: CoveredMatrixOrderItemTableReport) => {
    setDetailsItemId(row.id);
    setDetailsSnapshot(row);
  },[]);
  return <>
    <CommonTableUI
      reports={reports}
      onAction={onAction}
      sortingType={sortingType}
      setSortingType={setSortingType}
      getExtraTypeUI={getExtraTypeUI}
      AdditionalBody={getMatrixItemTableAdditional(openDetails)}
      tableHeaderClassName="!px-1 !py-1 !text-xs !whitespace-pre-line !leading-tight [&_svg]:!inline-block [&_svg]:!h-4 [&_svg]:!w-4"
      tableBoxClassName="!mx-0 !max-h-[226px] !w-full !max-w-full !overflow-x-auto !overflow-y-auto [&_table]:!w-full [&_table]:!table-fixed [&_thead_th]:!sticky [&_thead_th]:!top-0 [&_thead_th]:!z-20 [&_thead_th]:!bg-white [&_th]:!px-1 [&_th]:!py-1 [&_td]:!px-1 [&_td]:!py-1 [&_td]:!text-xs [&_td]:whitespace-nowrap [&_th:nth-child(1)]:!w-8 [&_td:nth-child(1)]:!w-8 [&_th:nth-child(2)]:!w-[110px] [&_td:nth-child(2)]:!w-[110px] [&_th:nth-child(3)]:!w-12 [&_td:nth-child(3)]:!w-12 [&_th:nth-child(4)]:!w-[58px] [&_td:nth-child(4)]:!w-[58px] [&_th:nth-child(5)]:!w-[58px] [&_td:nth-child(5)]:!w-[58px] [&_th:nth-child(6)]:!w-12 [&_td:nth-child(6)]:!w-12 [&_th:nth-child(7)]:!w-[72px] [&_td:nth-child(7)]:!w-[72px] [&_th:nth-child(8)]:!w-[78px] [&_td:nth-child(8)]:!w-[78px] [&_th:nth-child(9)]:!w-[60px] [&_td:nth-child(9)]:!w-[60px] [&_th:nth-child(10)]:!w-[72px] [&_td:nth-child(10)]:!w-[72px] [&_th:nth-child(11)]:!w-[94px] [&_td:nth-child(11)]:!w-[94px] [&_th:nth-child(12)]:!w-[94px] [&_td:nth-child(12)]:!w-[94px] [&_th:nth-child(13)]:!w-[94px] [&_td:nth-child(13)]:!w-[94px] [&_th:nth-child(14)]:!w-[72px] [&_td:nth-child(14)]:!w-[72px] [&_th:nth-child(15)]:!w-8 [&_td:nth-child(15)]:!w-8 [&_th:nth-child(16)]:!w-[62px] [&_td:nth-child(16)]:!w-[62px] [&_th:nth-child(3)]:!bg-[#a8dfbd] [&_th:nth-child(3)]:!text-green-900 [&_th:nth-child(4)]:!bg-[#a8dfbd] [&_th:nth-child(4)]:!text-green-900 [&_td:nth-child(3)]:!bg-[#eaf8ef] [&_td:nth-child(4)]:!bg-[#eaf8ef] [&_th:nth-child(5)]:!bg-[#f8c5d2] [&_th:nth-child(5)]:!text-slate-900 [&_th:nth-child(6)]:!bg-[#f8c5d2] [&_th:nth-child(6)]:!text-slate-900 [&_td:nth-child(5)]:!bg-[#fde9ed] [&_td:nth-child(6)]:!bg-[#fde9ed]"
    />
    {detailsSnapshot? <MatrixItemVolumeDetailsModal
      row={currentDetailsRow||detailsSnapshot}
      onClose={() => {
        setDetailsItemId(null);
        setDetailsSnapshot(null);
      }}
    />:null}
  </>;
};

export const getMatrixItemExtraTypeUI=({ headerName,extraType,row,cellType,translateHeaderName }: IExtraTypeUIProps<CoveredMatrixOrderItemTableReport>) => {
  switch(extraType) {
    case ExtraType.WithChart:
      return <ChartSearchParamUI {...{ row,headerName,cellType,translateHeaderName }} />;
    default:
      return <></>;
  }
};
